export default {
  width: 274,
  height: 246,
  maxTextLength: 32,
  fixedDigits: 10
};
